import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const English = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg width={`${size}px`} height={`${size}px`} fill="none" {...props}>
    <G clipPath="url(#a)">
      <Path
        d="M13.758 5.373C14.586 6.17 15 7.396 15 9.037v5.162c0 .5-.15.895-.455 1.174-.305.279-.726.421-1.27.421-.508 0-.922-.149-1.228-.447-.312-.298-.468-.681-.468-1.154v-.162a2.71 2.71 0 0 1-1.195 1.322c-.556.318-1.215.48-1.961.48-.795 0-1.52-.155-2.166-.454a3.705 3.705 0 0 1-1.527-1.277 3.164 3.164 0 0 1-.563-1.829c0-.824.217-1.472.658-1.939.441-.473 1.14-.817 2.118-1.025.97-.214 2.3-.317 3.991-.317h.625v-.409c0-.642-.15-1.102-.442-1.394-.292-.292-.787-.435-1.473-.435-.685 0-1.676.227-2.966.688-.366.168-.679.253-.93.253-.353 0-.631-.117-.835-.357-.21-.234-.312-.545-.312-.928 0-.304.075-.557.217-.752.143-.194.374-.382.693-.551.556-.292 1.242-.519 2.043-.687a11.54 11.54 0 0 1 2.382-.253c1.724 0 2.994.402 3.829 1.2l-.007.006Zm-2.844 7.425c.427-.447.645-1.03.645-1.744v-.39h-.408c-1.29 0-2.199.098-2.715.299-.516.201-.78.558-.78 1.077 0 .428.149.771.44 1.037.293.266.666.402 1.114.402.7 0 1.27-.227 1.697-.674l.007-.007Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default English
